import { Grid } from '@mui/material';
import HostInputComponent from '../input/host-input-component';
import HostButtonComponent from '../button/host-button-component';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const HostContainerComponent: React.FC<any> = ({ client, host, setHost, updateClient }: any) => {
    const [isValidHost, setIsValidHost] = useState(true);
    const { t } = useTranslation();
    const addNewHost = () => {
        const newClientData = {
            ...client!,
            hosts: [...client!.hosts, host],
        };

        updateClient(newClientData, t('hostAdded'));
        setHost('');
        setIsValidHost(true);
    };

    return (
        <Grid container sx={{ mt: 2 }}>
            <HostInputComponent
                host={host}
                setHost={setHost}
                isValidHost={isValidHost}
                setIsValidHost={setIsValidHost}
                addNewHost={addNewHost}
                client={client}
            />
            <HostButtonComponent host={host} isValidHost={isValidHost} addNewHost={addNewHost} />
        </Grid>
    );
};

export default HostContainerComponent;
